import { styled } from 'Theme'

export const StyledListDescription = styled.p`
  color: ${({ theme }): string => theme.colors.primary};
  font-size: ${({ theme }): string => theme.list.item.description.fontSize};
  line-height: ${({ theme }): string => theme.list.item.description.lineHeight};
`
